import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1320102b")
const _hoisted_1 = { class: "file-upload-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = { class: "input-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "files"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["value", "onKeydown"]
const _hoisted_8 = { class: "action-button" }
const _hoisted_9 = ["disabled"]
_popScopeId()

import IconClip from '@/assets/icons/icon_clip.svg';
import IconCross from '@/assets/icons/icon_cross.svg';
import IconSmile from '@/assets/icons/icon_smile.svg';
import IconSendMessage from '@/assets/icons/icon_send-message.svg';
import { Components } from '@brskl/core';
import { postExternalWebViewMessage } from '@/core/utils/webView';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import FileUpload from 'primevue/fileupload';
import ChatFilePreview from '@/core/components/Chat/ChatFilePreview.vue';

enum ExternalWebViewEvent {
  AttachFilePressed = 'attachFilePressed',
}


export default _defineComponent({
  props: {
    message: { type: String, required: true },
    position: { type: [String, String], required: true },
    isSendDisabled: { type: Boolean, required: true }
  } as unknown as undefined,
  setup(__props: {
  message: string,
  position: 'fixed' | 'absolute',
  isSendDisabled: boolean,
}, { expose, emit }: { emit: ({
  'change-message': (message: string) => void,
  'send-message': (event: Event) => void,
  'select-emoji': (emoji: string) => void,
}), expose: any, slots: any, attrs: any }) {

const { EmojiPicker } = Components;
const maxFileSize = 20000000;





const files = ref([]);
const attachment = ref(null);
const input = ref(null);

const getAttachedFiles = () => attachment.value.files;
const resetAttachedFiles = () => {
  attachment.value.files = [];
  attachment.value.uploadedFiles = [];
  attachment.value.uploadedFileCount = 0;
  files.value = [];
};
const removeAttachedFile = (deletingFile: unknown) => {
  const newFiles = files.value.filter((file) => file !== deletingFile);
  files.value = newFiles;
  attachment.value.files = newFiles;
  attachment.value.uploadedFileCount = newFiles.length || 0;
};

const uploadingFiles = computed(() => files.value.map((file) => ({
  nativeFile: file,
  file: {
    id: `${file.name}-${file.size}-${file.type}-${file.lastModified}`,
    name: file.name,
    preview: file.objectURL,
    size: file.size,
    file_extension: file.type.split('/').pop(),
  },
})));

const autoResizeInput = () => {
  const inputEl = input.value;
  inputEl.style.height = 'auto';
  const lineHeight = parseFloat(getComputedStyle(inputEl).lineHeight);
  const maxHeight = lineHeight * 3 + 16;
  inputEl.style.height = inputEl.scrollHeight > maxHeight
    ? `${maxHeight}px`
    : `${inputEl.scrollHeight}px`;
};

const onMessageChange = (event: Event) => {
  autoResizeInput();
  const message = event.target.value;
  emit('change-message', message);
};

const onEnter = (event: KeyboardEvent) => {
  if (event.shiftKey) return;
  event.preventDefault();
  emit('send-message', event)
};

const onUploadedFilesChanged = (event) => {
  files.value = event?.files || [];
};

const onFileDelete = (file) => {
  files.value = files.value.filter((item) => item !== file);
  attachment.value.files = files.value;
};

const onUploadClick = ({ chooseCallback }) => {
  chooseCallback();
  postExternalWebViewMessage(ExternalWebViewEvent.AttachFilePressed);
};

const onMessageSendClick = (event) => {
  emit('send-message', event);
};

onMounted(() => {
  window.addEventListener('resize', autoResizeInput);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', autoResizeInput);
});

expose({
  getAttachedFiles,
  resetAttachedFiles,
  removeAttachedFile,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", { [`_${__props.position}`]: !!__props.position }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(FileUpload), {
        ref: attachment,
        "max-file-size": maxFileSize,
        "choose-label": "",
        onSelect: onUploadedFilesChanged,
        onRemove: onUploadedFilesChanged
      }, {
        header: _withCtx(({ chooseCallback }) => [
          _createElementVNode("button", {
            class: "action-button",
            onClick: ($event: any) => (onUploadClick({ chooseCallback }))
          }, [
            _createVNode(_unref(IconClip))
          ], 8, _hoisted_2)
        ]),
        content: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(uploadingFiles).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uploadingFiles), ({ file, nativeFile }) => {
              return (_openBlock(), _createElementBlock("div", {
                key: file.id,
                class: "file-wrapper"
              }, [
                _createVNode(ChatFilePreview, { file: file }, null, 8, ["file"]),
                _createElementVNode("button", {
                  class: "delete-file",
                  onClick: ($event: any) => (onFileDelete(nativeFile))
                }, [
                  _createVNode(_unref(IconCross))
                ], 8, _hoisted_6)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("textarea", {
        ref: input,
        value: __props.message,
        placeholder: "Текст сообщения",
        class: "input",
        rows: "1",
        onInput: onMessageChange,
        onKeydown: _withKeys(onEnter, ["enter"])
      }, null, 40, _hoisted_7)
    ]),
    _createVNode(_unref(EmojiPicker), {
      class: "emoji-picker",
      onOnChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select-emoji', $event)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", _hoisted_8, [
          _createVNode(_unref(IconSmile))
        ])
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      class: "action-button",
      disabled: __props.isSendDisabled,
      onClick: onMessageSendClick
    }, [
      _createVNode(_unref(IconSendMessage))
    ], 8, _hoisted_9)
  ], 2))
}
}

})